import type { ToastRootProps } from 'radix-vue'
import type { HTMLAttributes } from 'vue'

export { default as Toast } from './Toast.vue'
export { default as ToastAction } from './ToastAction.vue'
export { default as ToastClose } from './ToastClose.vue'
export { default as ToastDescription } from './ToastDescription.vue'
export { default as Toaster } from './Toaster.vue'
export { default as ToastProvider } from './ToastProvider.vue'
export { default as ToastTitle } from './ToastTitle.vue'
export { default as ToastViewport } from './ToastViewport.vue'
export * from './use-toast'

import { cva, type VariantProps } from 'class-variance-authority'

export const toastVariants = cva(
  'group pointer-events-auto relative block w-full items-center justify-between space-x-4 mb-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]_translate-x-0 data-[swipe=end]_translate-x-[--radix-toast-swipe-end-x] data-[swipe=move]_translate-x-[--radix-toast-swipe-move-x] data-[swipe=move]_transition-none data-[state=open]_animate-in data-[state=closed]_animate-out data-[swipe=end]_animate-out data-[state=closed]_fade-out-80 data-[state=closed]_slide-out-to-right-full data-[state=open]_slide-in-from-top-full data-[state=open]_sm_slide-in-from-bottom-full',
  {
    variants: {
      variant: {
        default: 'border bg-background border-border',
        destructive: 'border bg-background border-destructive',
        warning: 'border bg-background border-border',
        success: 'border bg-background border-border',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

type ToastVariants = VariantProps<typeof toastVariants>

export interface ToastProps extends ToastRootProps {
  class?: HTMLAttributes['class']
  variant?: ToastVariants['variant']
  onOpenChange?: ((value: boolean) => void) | undefined
}
